import React from 'react';

import './Loading.css';

const Loading = ({ className, center = false }) => (
  <div className={ className }>
    <div className={ `dot-flashing ${center ? 'm-auto' : undefined}` }></div>
  </div>
);

export default Loading;